export const GoogleMapApiConfig = 'AIzaSyDhu88RgPI203N7-RMUohxUR-EhSK9RoJE';